import { render } from "./warranty.vue?vue&type=template&id=ba5a79c2"
import script from "./warranty.vue?vue&type=script&lang=js"
export * from "./warranty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__